const banners = document.querySelectorAll('.banner')
const callBanners = document.querySelectorAll('.js-call-banner')
const mediaQuery = window.matchMedia('(max-width: 576px)')

export function openBanner(banner) {
	document.body.style.overflow = 'hidden'
	document.querySelector('.header').style.overflow = 'hidden'
	banner.style.display = 'block'
	setTimeout(() => banner.classList.add('js-banner-show'), 100)
}

export function closeBanner(banner) {
	banner.classList.remove('js-banner-show')
	setTimeout(() => {
		banner.style.display = 'none'
		document.body.style.overflow = ''
	}, 300);

	setTimeout(() => {
		document.querySelector('.header').style.overflow = ''
	}, 400)

}


if (banners.length > 0 && callBanners.length > 0) {
	const clickHandlers = {}

	function handleClickOnMobile(callBanner) {
		const bannerId = callBanner.dataset.bannerId
		const bannerToShow = document.getElementById(bannerId)

		if (bannerToShow) {
			openBanner(bannerToShow)
		}
	}

	const handleClickOnMobileFunction = function (e) {
		if (e.matches) {
			callBanners.forEach(callBanner => {
				if (callBanner.classList.contains('js-different-behavior')) {
					const clickHandler = (e) => {
						e.preventDefault()
						handleClickOnMobile(callBanner)
					}
					callBanner.addEventListener('click', clickHandler)
					clickHandlers[callBanner.dataset.bannerId] = clickHandler
				}
			})
		} else {
			callBanners.forEach(callBanner => {
				if (callBanner.classList.contains('js-different-behavior')) {

					const clickHandler = clickHandlers[callBanner.dataset.bannerId]
					if (clickHandler) {
						callBanner.removeEventListener('click', clickHandler)
						delete clickHandlers[callBanner.dataset.bannerId]
					}
				}
			})
		}
	}

	mediaQuery.addEventListener('change', handleClickOnMobileFunction)


	callBanners.forEach(callBanner => {
		callBanner.addEventListener('click', (e) => {
			e.preventDefault()
			if (!callBanner.classList.contains('js-different-behavior')) {
				const bannerId = callBanner.dataset.bannerId
				const bannerToShow = document.getElementById(bannerId)

				if (bannerToShow) {
					openBanner(bannerToShow)
				}
			}
		})
	})


	banners.forEach(banner => {
		const btnClose = banner.querySelector('.banner__close')
		const overlay = banner.querySelector('.banner__overlay')

		btnClose.addEventListener('click', () => closeBanner(banner))
		overlay.addEventListener('click', () => closeBanner(banner))
	})

	handleClickOnMobileFunction(mediaQuery)
}
